import {
  ViewRecentArticles,
  ViewCatalog,
  ViewArticleOverview,
  ViewPressOverview,
  ViewRelatedHelpPages,
  ViewMaterialTypes,
  ViewCrisisBanner,
} from '../implementations';

const mappers = {
  views_block__recent_articles_block_1: ViewRecentArticles,
  views_block__catalogus_block_1: ViewCatalog,
  views_block__crisis_banner_block_1: ViewCrisisBanner,
  views_block__recent_articles_overview: ViewArticleOverview,
  views_block__recent_articles_press: ViewPressOverview,
  views_block__related_help_pages_block_1: ViewRelatedHelpPages,
  views_block__related_help_pages_block_2: ViewRelatedHelpPages,
  views_block__related_help_pages_block_3: ViewRelatedHelpPages,
  views_block__related_help_pages_block_4: ViewRelatedHelpPages,
  views_block__related_help_pages_block_5: ViewRelatedHelpPages,
  views_block__related_help_pages_block_6: ViewRelatedHelpPages,
  views_block__related_help_pages_block_7: ViewRelatedHelpPages,
  views_block__materials_block_1: ViewMaterialTypes,
};

export default mappers;
